import './Start.css';
import React, { useContext, useEffect, useState } from 'react';
import { SocketContext } from '../components/SocketContext';
import SelectRoomComponent from "../components/SelectRoomComponent";
import { RestFetcher } from '../helpers/RestFetcher'
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import FaceSelector from '../components/FaceSelector';

function isNumber(value) {
  return typeof value === 'number';
}

const Start = () => {
  
  const socket = useContext(SocketContext);
  const [rooms, setRooms] = useState([]);
  const navigate = useNavigate(); // Hook for navigation
  let chosenName = 'Mr. Player';
  let chosenFaceIndex = 0;

  var storedName = localStorage.getItem("chosenName");
  if (storedName != null) {
    chosenName = storedName;
  }

  var storedFace = localStorage.getItem("chosenFace");
  if (storedFace !== null) {
    console.log('Stored face:', storedFace);
    chosenFaceIndex = Number(storedFace);
    console.log(chosenFaceIndex + "is number" + isNumber(Number(chosenFaceIndex)));
  }

  var fetchRooms = () => {  // Function to fetch rooms
    var fetcher = new RestFetcher();

    fetcher.fetchRooms().then(roomsArray => {
      if (roomsArray && roomsArray.length > 0) {
        console.log('Fetched rooms:', roomsArray);
        setRooms(roomsArray);
      }
    }).catch(error => {
      console.error('Error fetching rooms:', error);
      setTimeout( () => { fetchRooms()}, 2000);
    });
  }

  useEffect(() => {
    if (socket) {
      console.log('emit leave room')
      socket.emit('leaveroom');
    }
    if (rooms.length === 0) {
      fetchRooms();
    }

  }, []);

  function handleInputChange(e) {
    chosenName = e.target.value;
  }

  function handleFaceOnChange(index) {
    console.log('Selected face:', index);
    chosenFaceIndex = index;
    localStorage.setItem("chosenFace", chosenFaceIndex);
  }

  function handleRoomSelected(room) {
    console.log("Selected room:", room, ' Selectecd name', chosenName);

    if (chosenName !== '') {
      localStorage.setItem("chosenName", chosenName);

      navigate(`/Room`, { state: { name: room, playerName: chosenName, sprite: chosenFaceIndex } });
    }
  }

  return (
    <div id="startpage">
      <h1> &lt;Twibble&gt;</h1>
      
      {rooms ? (
        <>
        <span className="textwrap"><h2>Pick a name and face</h2></span>
        
        <FaceSelector
            spriteSheet="bigfaces3.png"
            frameWidth={275}
            frameHeight={375}
            rows={3}
            cols={3}
            onChange={handleFaceOnChange}
            startFaceIndex={chosenFaceIndex}
          />
            <div className="nameinput">
            <TextField
              required
              id="outlined-required"
              label="Required"
              defaultValue={chosenName}
              onChange={handleInputChange}
            />
          </div>
          <br />
          <div className="roomselector">
            <span className="textwrap"><h2>then choose your room:</h2></span>
            <SelectRoomComponent onRoomSelected={handleRoomSelected} />
          </div>
          
        </>
      ) : <div>Connecting...</div>}
    </div>
  );
};

export default Start;